export const isSlateElement = (element: HTMLElement): boolean => {
  if (!element) {
    return false;
  }
  const datasetKeys = Object.keys(element.dataset);
  return datasetKeys.some((key) => key.startsWith('slate'));
};
